<template>
<div class="col">
  <div class="top_header_item"> 
    <i>
      <slot name="icon"></slot>
    </i>  
    <div class="top_header_text">
      <slot></slot>
    </div>
  </div>
</div>   
</template>

<style scoped>
.top_header_item {
  height: 50px;
  line-height: 50px;
  color: var(--clr-text);
  display: flex;
}
i {
  padding-left: 0.5rem;
}
.top_header_text {
  text-transform: uppercase;
  padding-left: 0.5rem;
}

</style>
